import { EditOutlined } from "@mui/icons-material";
import { Button, useTheme } from "@mui/material";
import { FC } from "react";

export const EditButton: FC<{ onClick?: () => void }> = ({ onClick }) => {
  const theme = useTheme();

  return (
    <Button
      onClick={onClick}
      sx={{
        minWidth: "auto",
        padding: "7px",
        transition: "none",
        "&:hover": {
          backgroundColor: theme.colors.secondary[1],
        },
      }}
      variant="text"
    >
      <EditOutlined sx={{ fontSize: 18, color: theme.colors.secondary[5] }} />
    </Button>
  );
};
